import { TranslocoService } from '@ngneat/transloco';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { ToolboxCandidateModel } from 'projects/core/src/lib/models/toolbox-candidate.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-toolbox-candidate-list',
  templateUrl: './toolbox-candidate-list.component.html',
  styleUrls: ['./toolbox-candidate-list.component.scss']
})
export class ToolboxCandidateListComponent extends BaseList implements OnInit {

  public candidates: Array<ToolboxCandidateModel> = [];

  protected rightLoad = 'admin.toolboxcandidate.list';
  protected rightNew = 'admin.toolboxcandidate.create';
  protected rightOpen = 'admin.toolboxcandidate.show';

  protected apiUrl = '/toolbox-candidates';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    protected transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.toolbox-candidates'));
    this.loadList();
  }

  public loadList(): void {
    this.loading = true;
    this.api.getModels('toolbox-candidates').subscribe({
      next: (candidates: any) => {
        this.candidates = candidates.data.map((entry: any) => {
          const candidate = new ToolboxCandidateModel().deserialize(entry);
          candidate.setTranslocoService(this.transloco);
          return candidate;
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
